module.exports = __webpack_public_path__ + "static/media/activeLogo.1a189eee.png";